import React from "react";
import { CHAT_DEMO_CALENDAR_HINT } from "../../lib/albisVoice";
import {
  getSchoolEmailDemo,
  schoolEmailDemoToAgendaItems,
} from "../../lib/schoolEmailDemo";
import { todayYmdZurich } from "../../lib/schoolAttention";
import ChatAgendaCard from "../ChatAgendaCard/ChatAgendaCard";
import "./SchoolEmailDemo.css";

/**
 * Archetypal KiTa-mail → Aufgabe/Termin as the same list chrome as live chat.
 * @param {{ compact?: boolean, showBadge?: boolean, variant?: string }} props
 */
export default function SchoolEmailDemo({
  compact = false,
  showBadge = true,
  variant = "deadline",
}) {
  const todayYmd = todayYmdZurich();
  const { receivedLabel, sourceLabel, sourceQuote, events } = getSchoolEmailDemo(
    todayYmd,
    variant,
  );
  const items = schoolEmailDemoToAgendaItems(events);

  return (
    <article
      className={`school-email-demo${compact ? " school-email-demo--compact" : ""}`}
      aria-label="Beispiel: erkannte Aufgabe und Termin aus einer Eltern-Mail"
    >
      {showBadge ? (
        <p className="school-email-demo-badge">{receivedLabel}</p>
      ) : null}
      {sourceQuote ? (
        <blockquote className="school-email-demo-quote">
          {sourceLabel ? (
            <p className="school-email-demo-quote-label">{sourceLabel}</p>
          ) : null}
          <p className="school-email-demo-quote-text">{sourceQuote}</p>
        </blockquote>
      ) : null}
      <ChatAgendaCard items={items} showCalendarCue />
      <p className="school-email-demo-calendar-hint">{CHAT_DEMO_CALENDAR_HINT}</p>
    </article>
  );
}
